import { Screen } from '@bonanza-social/navigation';
import { ChangePassword } from '../components';
import { KeyboardSpacer } from '@bonanza-social/moonlight';

function ChangePasswordScreen() {
  return (
    <Screen paddingBottom="safe-area-inset-bottom">
      <ChangePassword />
      <KeyboardSpacer isInsideSafeAreaView additionalOffset={-70} />
    </Screen>
  );
}
export default ChangePasswordScreen;
